import { render } from "./NotificationDrawer.vue?vue&type=template&id=68647300&scoped=true"
import script from "./NotificationDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationDrawer.vue?vue&type=script&lang=js"

import "./NotificationDrawer.vue?vue&type=style&index=0&id=68647300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68647300"]])

export default __exports__